import Vue from "vue";

import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import ResgatarPontosComponent from "@/components/parent/crud/cliente/resgatarPontos";
import resgatarPontosComponent from "@/components/parent/crud/cliente/resgatarPontos.vue";
import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component } from "@/decorators";
import CampanhaPontuacaoModel from "@/models/programafidelidade/campanhaPontuacaoModel";
import campanhaService from "@/services/campanhaService";
import "../crud.scss";

@Component({
    components: {
        fieldsetComponent,
        buttonIncluirComponent,
        shortcutComponent,
        resgatarPontosComponent,
    },
})
export default class PontosComponent extends Vue {
    private shortcutComponent: ShortcutComponent = null;
    private resgatarPontosComponent: ResgatarPontosComponent = null;

    private model: CampanhaPontuacaoModel[] = [];
    clienteId = 0;

    public async load(documento: string, clienteId: number) {
        this.model = await campanhaService
            .getPontosByDocumento(documento)
            .withLoading()
            .resolveWithJSON<CampanhaPontuacaoModel[]>();

        this.clienteId = clienteId;
        if (this.model.length === 0) {
            return await this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.nenhumaPontuacao"));
        }

        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;
        this.shortcutComponent.show();
    }

    private onResgatarPontos(campanha: CampanhaPontuacaoModel) {
        this.resgatarPontosComponent = this.$refs.resgatarPontosComponent as ResgatarPontosComponent;
        this.resgatarPontosComponent.load(campanha.campanhaId);
    }

    private onResgateOk() {
        this.shortcutComponent.hide();
    }
}
